import { Col, Container, Row } from "react-bootstrap";

interface ContentSectionProps {
    title: string;
    children: React.ReactNode;
}
export const ContentSection: React.FC<ContentSectionProps> = ({ title, children }) => {
    return (
        <section className="content-section py-5">
            <Container>
                <Row>
                    <Col md={6} className="px-0">
                        <h2 className="mb-4 Heading_h2">{title}</h2>
                    </Col>
                    <Col md={6} className="px-0">{children}</Col>
                </Row>
            </Container>
        </section>
    );
};